

export const defaultSetting = {
    theme: "light",
    language: "vi",
    pinnedMenu: false,
    openMenu: false,
};
